export default __webpack_public_path__ + "static/media/trust-logo-without-bg.139b5d4a.svg";